import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import playgroundActions from 'redux/actions/playgroundActions'
import Modalizer from 'components/modalizer/modalizer'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import NearpodPicker from 'components/nearpod_picker/nearpod_picker'

class PlaygroundNearpodPicker extends PureComponent {

	constructor() {
		super()
		this.cancel = this.cancel.bind(this)
		this.onFilesPicked = this.onFilesPicked.bind(this)
		this.onFileError = this.onFileError.bind(this)
		this.acceptedFiles = this.acceptedFiles.bind(this)
	}

	cancel() {
		this.props.actions.cancel()
	}

	onFilesPicked(files) {
		this.props.actions.pick(this.props.pickerType, files)
	}

	onFileError() {
		this.props.actions.fileError()
	}

	acceptedFiles() {
		switch (this.props.pickerType) {
			case 'audio':
				return ['audio']
			case 'gif':
				return ['gif']
			case 'image':
				return ['image', 'video']
			case 'video':
				return ['video', 'image']
			case 'pdf':
				return ['pdf']
			case 'web':
				return ['web']
		}
	}

	render() {
		return (
			<Modalizer width='570px' height={this.props.pickerType!=='web'?'564px':''} nopadding={true} closeAction={this.cancel}>
				<NearpodPicker
					onFilesPicked={this.onFilesPicked}
					closeHandler={this.cancel}
					pickerType={this.props.pickerType}
					accept={this.acceptedFiles()}
					multiselect={false}
					onFileError={this.onFileError} />
			</Modalizer>
		)
	}
}

PlaygroundNearpodPicker.propTypes = {
	modalName: PropTypes.string,
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		pick: playgroundActions.nearpodPickerPick,
		fileError: playgroundActions.nearpodPickerFileError,
		cancel: playgroundActions.nearpodPickerCancel,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(PlaygroundNearpodPicker)
